<div class="mx-5">

    <div class="card mt-3 shadow-sm">
        <div class="card-body" ID="suppplierListContainer">
            <kendo-grid #grid="kendoGrid" [data]="gridData" [pageSize]="state.take" [skip]="state.skip" [sort]="state.sort"
                [filter]="state.filter" [sortable]="true" [pageable]="{pageSizes: [10,20,50,100]}" [filterable]="'menu'"
                (cellClick)="editSupplier($event)" (dataStateChange)="dataStateChange($event)">

                <kendo-grid-column *ngIf="sharedDataSvc.debug" field="Id" Title="Id" [width]="70">
                </kendo-grid-column>
                <kendo-grid-column field="SupplierName" [width]="300">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Nom_du_fournisseur"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="UniqueNum" [width]="180">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Numero_d_identification"></div>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <div class="d-flex align-items-start">
                            <div style="width:60px;">
                                <paflabel class="mr-1" [lblCod]="dataItem.FunctionalId"></paflabel>:
                            </div> 
                            <div class=ml-1>{{getUniqueNum(dataItem)}}</div>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <!-- <kendo-grid-column field="NumTiers" title="NumTiers" [width]="150">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="NumTiers"></div>
                    </ng-template>
                </kendo-grid-column> -->
                <kendo-grid-column field="City" title="Ville" [width]="250">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Ville"></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="HQSiret" title="Siege" [width]="90">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Siege"></div>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        {{isSiegeDisplay(dataItem) | async}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="230">
                    <ng-template kendoGridHeaderTemplate>
                        <div paflabel="Statut"></div>
                    </ng-template>
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <supplier-statut-badge [supplierStatutId]="dataItem.StatutId"></supplier-statut-badge>
                    </ng-template>
                </kendo-grid-column>Id
                <kendo-grid-excel [fileName]="excelExportFileName" [fetchData]="allData"></kendo-grid-excel>
            </kendo-grid>
        </div>
    </div>

    <PRE *ngIf="sharedDataSvc.debug">
       RESULTATS : {{suppliers | json}}
    </PRE>


</div>